export default "__VITE_ASSET__BUdfD7Ck__"